export * from './search-results-tool.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/tools/search-results-tool/index.ts